// import { ITokenData, ITokenRequest } from '../../services/api/requests/getToken';
import {
  CHANGE_THEME,
  ChangeThemeAction,
  GET_AUDIO_LIST,
  GetAudioListAction,
  LOGOUT,
  LogOutAction,
  SET_LOADER,
  SET_TEMPORARY_DRAWER,
  SetLoaderAction,
  SetShowTemporaryDrawerAction,
} from './types';

export function changeTheme(payload: string): ChangeThemeAction {
  return {
    type: CHANGE_THEME,
    payload,
  };
}

export function logOutUser(): LogOutAction {
  return {
    type: LOGOUT,
  };
}

// export function logInUser(payload: ITokenRequest): LogInAction {
//   return {
//     type: LOGIN_USER,
//     // payload,
//   };
// }
//
// export function saveUserData(payload: ITokenData): LogInSuccessAction {
//   return {
//     type: LOGIN_USER_SUCCESS,
//     // payload,
//   };
// }

export function setLoader(payload: boolean): SetLoaderAction {
  return {
    type: SET_LOADER,
    payload,
  };
}

export function setShowTemporaryDrawer(
  payload: boolean,
): SetShowTemporaryDrawerAction {
  return {
    type: SET_TEMPORARY_DRAWER,
    payload,
  };
}

export function getAudioList(payload: any): GetAudioListAction {
  return {
    type: GET_AUDIO_LIST,
    payload,
  };
}
